export default {
  data () {
    return {
      title: '',
      subtitle: '',
    }
  },
  methods: {  
    titleUpdated (title) {
      this.title = title
    },    
    subtitleUpdated (subtitle) {
      this.subtitle = subtitle
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/modal/logic/ModalAjax.js